// Generated from api/openapi/identity.yaml by make docs. Do not edit.
import { z } from "zod";

export const recoveryRequestSchema = z.object({
  "id": z.string().uuid(),
  "user_id": z.string().uuid(),
  "status": z.enum(["pending", "awaiting_info", "approved", "denied", "expired", "cancelled"]),
  "reason": z.string().optional(),
  "approved_by": z.string().uuid().optional(),
  "denied_by": z.string().uuid().optional(),
  "pass_id": z.string().uuid().optional(),
  "decision_note": z.string().optional(),
  "created_at": z.string().datetime({ offset: true }),
  "decided_at": z.string().datetime({ offset: true }).optional(),
  "expires_at": z.string().datetime({ offset: true })
});

export const recoveryRequestsPageSchema = z.object({
  "items": z.array(recoveryRequestSchema),
  "next_cursor": z.string().uuid().optional()
});

export const recoveryPassSchema = z.object({
  "id": z.string().uuid(),
  "user_id": z.string().uuid(),
  "status": z.enum(["active", "used", "expired", "revoked"]),
  "expires_at": z.string().datetime({ offset: true }),
  "used_at": z.string().datetime({ offset: true }).optional(),
  "revoked_at": z.string().datetime({ offset: true }).optional(),
  "verification_method": z.enum(["video_call", "in_person", "phone_call", "government_id", "manager_attestation", "other"]),
  "created_by": z.string().uuid(),
  "created_at": z.string().datetime({ offset: true })
});

export const recoveryPassesResponseSchema = z.object({
  "items": z.array(recoveryPassSchema)
});
